import { currencyData } from './json'
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export const scrollTo = (target, wrapDom = null) => {
  let wrapper = wrapDom || document.documentElement;
  let top = parseInt( wrapper.scrollTop);
  let dis = target - top;
  let intev = 10;
  let splice = dis / 30;

  let timer = window.setInterval(() => {
    top = top + splice;;
    wrapper.scrollTop = top;
    if (dis >= 0) {
      if (top >= target) {
        wrapper.scrollTop = target;
        window.clearInterval(timer);
      }
    }
    if (dis <= 0) {
      if (top <= target) {
        wrapper.scrollTop = target;
        window.clearInterval(timer);
      }
    }
  }, intev)
}
export const downloadFile = ({data, filename}) => {
  filename = filename.replace(/\"/g, '')
  const blob = new Blob([data], { type: 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(filename))
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob)
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', decodeURI(filename))
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }
    // 挂载a标签
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL)
  }
}
export const isIE = () => {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return true;
  } else {
    return false;
  }
}
export const getRandom = (m, n) => Math.floor(Math.random() * (m - n) + n)
//弹性调用方法
window.debounce_timer = [];
const spliceDebounceTimer = timer => window.debounce_timer.splice(window.debounce_timer.indexOf(timer), 1)
export const debounce = (fn, delay = 500) => {
  let timer = null;
  return function() {
    this.test = 'test';
    timer && clearTimeout(timer) && spliceDebounceTimer(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments)
      spliceDebounceTimer(timer)
    }, delay || 0)
    window.debounce_timer.push(timer);
  }
}
export const copyObj = obj => JSON.parse(JSON.stringify(obj))
export const fileInfo = file => {
  if(typeof file === 'string') return { name: file, url: file }
  else if(typeof file === 'object' && file != null) return { name: file.object_name || file.url, url: file.url }
  else return {}
}
export const getCurrencyName = code => {
  let item = currencyData.find(item => item.currency == code);
  return item ? item.name : '未知'
}
export const trim = str => str.replace(/(^\s*)|(\s*$)/g, "");
const fileKeys = ["id","mime_type","origin_name","size_byte","suffix","url"];
export const transFileObjToCode = (data) => {
  if(Array.isArray(data)){
    return data.map(item => transFileObjToCode(item))
  }else if(typeof data === 'object' && data instanceof Object){
    let keys = Object.keys(data);
    if(keys.length === fileKeys.length && 
      keys.every(item => fileKeys.indexOf(item) != -1)){
      return data.id;
    }else{
      let result = {};
      keys.forEach(key => {
        result[key] = transFileObjToCode(data[key])
      })
      return result;
    }
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/utils/index.js